var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-page"}},[_c('HeadToolBar'),_c('LandingContent'),_c('StartDialog'),_c('ExistingCustomerDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }